import {
  AddedRow,
  DeletedRow,
  InitialRow,
  ReorderRow,
} from '../../../../applications/ports/versionReportVersionRepository'
import {
  VersionReportPageConfig,
  VersionReportVersionPageRowEntity,
} from '../../../../domain/entity/version-report/VersionReportVersionEntity'

export const getNewTargetUuids = (config: VersionReportPageConfig): string[] =>
  config.tableRows

export const buildInitialRows = (
  config: VersionReportPageConfig
): InitialRow[] =>
  getNewTargetUuids(config).map((targetUuid, displayOrder) => ({
    targetUuid,
    displayOrder,
  }))

export const buildRowDiff = (
  config: VersionReportPageConfig,
  originalRows: VersionReportVersionPageRowEntity[]
): {
  addedRows: AddedRow[]
  deletedRows: DeletedRow[]
  reorderedRows: ReorderRow[]
} => {
  const newTargetUuids = getNewTargetUuids(config)
  const newTargetUuidsSet = new Set(newTargetUuids)

  const deletedRows: DeletedRow[] = originalRows
    .filter(r => !newTargetUuidsSet.has(r.targetUuid))
    .map(r => ({ rowUuid: r.uuid, lockVersion: r.lockVersion }))

  // 概況ページの表示順はツリー構造で決まり displayOrder を参照しないため。
  if (config.type === 'PROGRESS_OVERVIEW') {
    const originalTargetUuids = new Set(originalRows.map(r => r.targetUuid))
    const maxOrder = Math.max(-1, ...originalRows.map(r => r.displayOrder))
    const addedRows: AddedRow[] = newTargetUuids
      .filter(uuid => !originalTargetUuids.has(uuid))
      .map((uuid, i) => ({ targetUuid: uuid, displayOrder: maxOrder + 1 + i }))
    return { addedRows, deletedRows, reorderedRows: [] }
  }

  const originalRowByTargetUuid = new Map(
    originalRows.map(r => [r.targetUuid, r] as const)
  )

  const addedRows: AddedRow[] = []
  const reorderedRows: ReorderRow[] = []
  newTargetUuids.forEach((targetUuid, displayOrder) => {
    const original = originalRowByTargetUuid.get(targetUuid)
    if (!original) {
      addedRows.push({ targetUuid, displayOrder })
      return
    }
    if (original.displayOrder !== displayOrder) {
      reorderedRows.push({
        rowUuid: original.uuid,
        lockVersion: original.lockVersion,
        displayOrder,
      })
    }
  })

  return { addedRows, deletedRows, reorderedRows }
}
